import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { JsonComponent } from 'src/app/core/json/json.component';
import { MobileService, OrderStatus } from 'src/app/services/api/mobile/mobile.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';

@Component({
  selector: 'app-order-details-status',
  templateUrl: './order-details-status.component.html',
  styleUrls: ['./order-details-status.component.scss']
})
export class OrderDetailsStatusComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;

  orderStatus: OrderStatus;
  reloadDisabled: boolean;

  constructor(private mobileService: MobileService,
    private translate: TranslateService,
    private notificationService: NotificationsService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.reloadDisabled = false;
  }

  reloadStates() {
    this.reloadDisabled = true;
    this.mobileService.getOrderStatus(this.summary.externalId).subscribe(
      (data) => {
        this.orderStatus = data;
        this.reloadDisabled = false;
      },
      (err) => {
        this.notificationService.showNotification(this.translate.instant('ORDERS_KEY.orderStatusError'), NotificationLevel.ERROR);
        this.reloadDisabled = false;
      }
    )
  }

  showInitialScOrderState() {
    this.dialog.open(JsonComponent, {
      data: { title: this.translate.instant('ORDERS_KEY.initialScOrderState'), json: this.orderStatus.initialScOrderState },
      disableClose: false,
      minWidth: '850px',
      restoreFocus: false,
      autoFocus: false
    });
  }

  showMMOrderState() {
    this.dialog.open(JsonComponent, {
      data: { title: this.translate.instant('ORDERS_KEY.mmOrderState'), json: this.orderStatus.mmOrderState },
      disableClose: false,
      minWidth: '850px',
      restoreFocus: false,
      autoFocus: false
    });
  }

  showCurrentScOrderState() {
    this.dialog.open(JsonComponent, {
      data: { title: this.translate.instant('ORDERS_KEY.currentScOrderState'), json: this.orderStatus.currentScOrderState },
      disableClose: false,
      minWidth: '850px',
      restoreFocus: false,
      autoFocus: false
    });
  }

  showSharedBondLine() {
    this.dialog.open(JsonComponent, {
      data: { title: this.translate.instant('ORDERS_KEY.sharedBondLine'), json: this.orderStatus.sharedBondLine },
      disableClose: false,
      minWidth: '850px',
      restoreFocus: false,
      autoFocus: false
    });
  }

  showSharedBond() {
    this.dialog.open(JsonComponent, {
      data: { title: this.translate.instant('ORDERS_KEY.sharedBond'), json: this.orderStatus.sharedBond },
      disableClose: false,
      minWidth: '850px',
      restoreFocus: false,
      autoFocus: false
    });
  }

  showMMSharedBondOrderState() {
    this.dialog.open(JsonComponent, {
      data: { title: this.translate.instant('ORDERS_KEY.mmSharedBondOrderState'), json: this.orderStatus.mmSharedBondOrderState },
      disableClose: false,
      minWidth: '850px',
      restoreFocus: false,
      autoFocus: false
    });
  }

}
